/** @jsx jsx */
import { jsx } from '@emotion/core';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import { userChallenge } from 'actions/challenge.actions';
import { DetailsPage } from 'components/pages/DetailsPage';

const DetailsPageDataLoader = (): JSX.Element | null => {
  const dispatch = useDispatch();
  const { id: challengeId }: { id: string } = useParams();

  useEffect(() => {
    if (challengeId) {
      dispatch(userChallenge.request({ challengeId: +challengeId }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [challengeId]);

  return <DetailsPage />;
};

export default DetailsPageDataLoader;
